import {connect} from "react-redux";
import AccessRightDetail from "./AccessRightDetail";
import {compose} from "redux";
import {WithAppendHeaderAndFooterHOC} from "../../HOC/WithAppendHeaderAndFooterHOC";
import {WithAppendSidebarHOC} from "../../HOC/WithAppendSidebarHOC";
import {getMessengersList} from "../../globalState/app/actions";
import {getMessengersListSelector} from "../../globalState/app/selectros";



let mapStateToProps = (state) => {
    return {
        messengers: getMessengersListSelector(state),
    }
};



export default compose(connect(mapStateToProps, {getMessengersList}), WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC)(AccessRightDetail);



